import React from 'react';
import './App.scss';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import AppManageLayout from './appmanage/AppManageLayout';
import AppManageLoginScreen from './appmanage/Login/AppManageLoginScreen';
import OrderManagementScreen from './appmanage/OrderManagement/OrderManagementScreen';
import MenuManagementScreen from './appmanage/MenuManagement/MenuManagementScreen';
import StoreOperationScreen from './appmanage/StoreOperation/StoreOperationScreen';
import SalesStatsScreen from './appmanage/SalesStats/SalesStatsScreen';
import HomeScreen from './screen/Home/HomeScreen';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import AdminLoginScreen from './admin/Login/AdminLoginScreen';
import AdminSignupScreen from './admin/Signup/AdminSignupScreen';
import AdminLayout from './admin/AdminLayout';
import StoreManagementScreen from './admin/StoreManagement/StoreManagementScreen';
import PendingAdminsScreen from './admin/PendingAdmins/PendingAdminsScreen';
import { authState } from './RecoilStore';

function PublicLayout({ children }: { children: React.ReactElement }) {
  return (
    <>
      <Header />
      {children}
      <Footer />
    </>
  );
}

function RequireAppManageAuth({ children }: { children: React.ReactElement }) {
  const auth = useRecoilValue(authState);
  if (!auth?.token) {
    return <Navigate to="/appmanage/login" replace />;
  }
  return children;
}

function RequireAdminAuth({ children }: { children: React.ReactElement }) {
  const auth = useRecoilValue(authState);
  if (!auth?.token || !auth.isSuperAdmin) {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
}

function RequireMasterAdminAuth({ children }: { children: React.ReactElement }) {
  const auth = useRecoilValue(authState);
  if (!auth?.token || !auth.isSuperAdmin) {
    return <Navigate to="/admin/login" replace />;
  }
  if (!auth.isMasterAdmin) {
    return <Navigate to="/admin/stores" replace />;
  }
  return children;
}

function App() {

  return (
      <div className="App">

          <div className='Main'>

            <Routes>
              <Route
                path="/"
                element={
                  <PublicLayout>
                    <HomeScreen />
                  </PublicLayout>
                }
              />
              <Route path="/appmanage/login" element={<AppManageLoginScreen />} />

              <Route
                path="/appmanage"
                element={
                  <RequireAppManageAuth>
                    <AppManageLayout />
                  </RequireAppManageAuth>
                }
              >
                <Route index element={<Navigate to="orders" replace />} />
                <Route path="orders" element={<OrderManagementScreen />} />
                <Route path="menus" element={<MenuManagementScreen />} />
                <Route path="operations" element={<StoreOperationScreen />} />
                <Route path="stats" element={<SalesStatsScreen />} />
              </Route>

              <Route path="/admin/login" element={<AdminLoginScreen />} />
              <Route path="/admin/signup" element={<AdminSignupScreen />} />

              <Route
                path="/admin"
                element={
                  <RequireAdminAuth>
                    <AdminLayout />
                  </RequireAdminAuth>
                }
              >
                <Route index element={<Navigate to="stores" replace />} />
                <Route path="stores" element={<StoreManagementScreen />} />
                <Route
                  path="pending-admins"
                  element={
                    <RequireMasterAdminAuth>
                      <PendingAdminsScreen />
                    </RequireMasterAdminAuth>
                  }
                />
              </Route>

            </Routes>
          </div>

      </div>
  );
}


export default App;
